//  默认数据加载样式
const state = {
    DataLoading: false
}
const getters = {
    DataLoading: (state)  => state.DataLoading
}
const mutations = {
    showDataloader: state => state.DataLoading = true,
    hideDataloader: state => state.DataLoading = false
}
const actions = {
    showDataloader: ({commit}) => {
        commit('showDataloader');
    },
    hideDataloader: ({commit}) => {
        commit('hideDataloader');
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/Dataloading.js